import { render, staticRenderFns } from "./AccountLayer.vue?vue&type=template&id=0128dfb9&scoped=true&name=account-layer&"
import script from "./AccountLayer.vue?vue&type=script&lang=js&"
export * from "./AccountLayer.vue?vue&type=script&lang=js&"
import style0 from "./AccountLayer.vue?vue&type=style&index=0&id=0128dfb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0128dfb9",
  null
  
)

/* custom blocks */
import block0 from "./AccountLayer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports